import { Application } from 'stimulus'
import SharingController from './controllers/SharingController'
const app = Application.start()
app.register('sharing', SharingController)



// WEBPACK FOOTER //
// ./assets/js/main.js